import * as React from "react";
import { forwardRef } from "react";
const SvgCustomer = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11.728 8.281a4.99 4.99 0 1 0-7.497 0A6 6 0 0 0 0 14.004 1.995 1.995 0 0 0 1.996 16h11.973a1.996 1.996 0 0 0 1.996-1.996 6 6 0 0 0-4.237-5.723m-3.752-6.25a2.993 2.993 0 1 1 0 5.987 2.993 2.993 0 0 1 0-5.986m3.991 11.974H1.99a3.99 3.99 0 0 1 3.991-3.99h3.992a3.99 3.99 0 0 1 3.99 3.99z" }));
const ForwardRef = forwardRef(SvgCustomer);
export { ForwardRef as ReactComponent };
